module.exports = __webpack_public_path__ + "slogan.png?8e2cf0ae8e9e4838798a12e23c10a0c5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slogan.png
// module id = 135
// module chunks = 0